@if(pageLoading1 || pageLoading2 || pageLoading3 || pageLoading4){
<div class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
}
@if(
!pageLoading1 &&
(navbar.userAccess?.Follow_up=='Full' || navbar.userAccess?.Follow_up=='Readonly')
){
<div class="row g-0">
	<div class="col">
		<div class="card" @fadeInOut>
			<div class="card-header">
				<h5 style="font-size: 12px !important;" class="card-title text-dark mb-0">
					Follow-up Details for {{followUpDetails?.follow_up_date}}
				</h5>
			</div>
			<div class="card-body p-1">
				<form [formGroup]="moduleForm" (ngSubmit)="saveFollowUp_A()">
					<table class="table table-bordered">
						<tbody>
							<tr>
								<td>
									<div class="row mb-3">
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
											<div class="input-group">
												<div class="form-floating">
													<input class="form-control"
														[ngClass]="{'is-invalid':showError('follow_up_date')}"
														placeholder="" formControlName="follow_up_date" ngbDatepicker
														id="follow_up_date" #follow_up_date="ngbDatepicker"
														[minDate]="minDate" [container]="'body'" />
													<label for="follow_up_date">Follow-up Date*</label>
												</div>
												<button class="btn btn-outline-secondary"
													(click)="follow_up_date.toggle()" type="button">
													<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
												</button>
											</div>
											<p *ngIf="showError('follow_up_date')" class="text-danger">
												<span *ngIf="f.follow_up_date.errors?.required">
													Required
												</span>
												<span *ngIf="f.follow_up_date.errors?.incorrect">
													{{customError.follow_up_date}}
												</span>
											</p>
										</div>
										<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<ng-select [ngClass]="{'is-invalid':showError('visit_type_id')}"
												[items]="parent.allVisitType" (change)="apptTypeChanged(true)"
												bindLabel="name" bindValue="id" [clearable]="true" id="visit_type_id"
												formControlName="visit_type_id" placeholder="Appointment Type*"
												[appearance]="'outline'">
												<ng-template ng-label-tmp let-item="item">
													<img src="../../assets/img/appt-types/{{parent.appt_type_images[item.name]}}"
														class="appt-type-img" />
													{{item.name}}
												</ng-template>
												<ng-template ng-option-tmp let-item="item" let-search="searchTerm"
													let-index="index">
													<img src="../../assets/img/appt-types/{{parent.appt_type_images[item.name]}}"
														class="appt-type-img" />
													{{item.name}}
												</ng-template>
											</ng-select>
											<p *ngIf="showError('visit_type_id')" class="text-danger">
												<span *ngIf="f.visit_type_id.errors?.required">
													Required
												</span>
												<span *ngIf="f.visit_type_id.errors?.incorrect">
													{{customError.visit_type_id}}
												</span>
											</p>
										</div>
										<div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
											@if(showNonMedicalFields){
											<div class="medicine-supply-container">
												<ng-select [ngClass]="{'is-invalid':showError('medicine_supply')}"
													[items]="medicine_supply_list" bindLabel="name" bindValue="id"
													id="medicine_supply" formControlName="medicine_supply"
													placeholder="Medicine Supply" [appearance]="'outline'"
													[clearable]="true">
												</ng-select>
												<p *ngIf="showError('medicine_supply')" class="text-danger">
													<span *ngIf="f.medicine_supply.errors?.required">
														Required
													</span>
													<span *ngIf="f.medicine_supply.errors?.incorrect">
														{{customError.medicine_supply}}
													</span>
												</p>
											</div>
											@if(!isHandoverAfterClosed){
											<mat-checkbox [color]="'primary'" formControlName="is_handover"
												id="is_handover" class="float-start">
												Handover
											</mat-checkbox>
											<mat-checkbox [color]="'primary'" formControlName="is_referral_added"
												id="is_referral_added" (change)="reffFlagChanged()" class="float-start">
												Referral Added
											</mat-checkbox>
											<!-- @if(showReferralFields){
											<app-file-upload [allowedFiles]="allowedReferralFiles"
												[uploadFolder]="'referral_files'" (uploaded)="referralFileUploaded($event)"
												[cls]="'w-100px'">
											</app-file-upload>
											@if(f.referral_file.value){
											<div class="icon-container referral-file">
												<file-icon [file]="f.referral_file.value"></file-icon>
												<fa-icon [icon]="['fas', 'times-circle']" class="delete-icon text-danger"
													matTooltip="Delete" (click)="deleteReferralFile();"></fa-icon>
											</div>
											}
											} -->
											}
											}
										</div>
									</div>
								</td>
							</tr>
							@if(showOPDFields){
							<tr @fadeInOut>
								<td>
									<div class="row mb-3">
										<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
											<ng-select [ngClass]="{'is-invalid':showError('lab_test')}"
												[items]="labTestList" bindLabel="name" bindValue="id" id="lab_test"
												formControlName="lab_test" placeholder="OPD Lab Tests"
												[appearance]="'outline'" [clearable]="true" [multiple]="true"
												[closeOnSelect]="false">
											</ng-select>
											<p *ngIf="showError('lab_test')" class="text-danger">
												<span *ngIf="f.lab_test.errors?.required">
													Required
												</span>
												<span *ngIf="f.lab_test.errors?.incorrect">
													{{customError.lab_test}}
												</span>
											</p>
										</div>
									</div>
								</td>
							</tr>
							}
							@if(showIPDFields){
							<tr @fadeInOut>
								<td>
									<h5 class="fw-bold mb-2">Hospitalization Details:</h5>
									<div class="row">
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
											<ng-select [ngClass]="{'is-invalid':showError('hospitalization_status_id')}"
												[items]="parent.hospStatusList" bindLabel="name" bindValue="id"
												[clearable]="true" id="hospitalization_status_id"
												formControlName="hospitalization_status_id"
												placeholder="Hospitalization" [appearance]="'outline'"
												(change)="hospitalizationChanged()">
											</ng-select>
											<p *ngIf="showError('hospitalization_status_id')" class="text-danger">
												<span *ngIf="f.hospitalization_status_id.errors?.required">
													Required
												</span>
												<span *ngIf="f.hospitalization_status_id.errors?.incorrect">
													{{customError.hospitalization_status_id}}
												</span>
											</p>
										</div>
										@if (showAdmittedFields || showPreAdmittedFields || showDayCareFields) {
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
											<div class="input-group">
												<div class="form-floating">
													<input class="form-control"
														[ngClass]="{'is-invalid':showError('admission_date')}"
														placeholder="" formControlName="admission_date" ngbDatepicker
														id="admission_date" #admission_date="ngbDatepicker"
														[minDate]="minDate" [container]="'body'" />
													<label for="admission_date">
														Admission Date
														@if(isRequired('admission_date')){
														*
														}
													</label>
												</div>
												<button class="btn btn-outline-secondary"
													(click)="admission_date.toggle()" type="button">
													<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
												</button>
											</div>
											<p *ngIf="showError('admission_date')" class="text-danger">
												<span *ngIf="f.admission_date.errors?.required">
													Required
												</span>
												<span *ngIf="f.admission_date.errors?.incorrect">
													{{customError.admission_date}}
												</span>
											</p>
										</div>
										}
										@if (showDischargedFields) {
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
											<div class="input-group">
												<div class="form-floating">
													<input class="form-control"
														[ngClass]="{'is-invalid':showError('actual_discharge_date')}"
														placeholder="" formControlName="actual_discharge_date"
														ngbDatepicker id="actual_discharge_date"
														#actual_discharge_date="ngbDatepicker" [minDate]="minDate"
														[container]="'body'" />
													<label for="actual_discharge_date">
														Discharge Date
														@if(isRequired('actual_discharge_date')){
														*
														}
													</label>
												</div>
												<button class="btn btn-outline-secondary"
													(click)="actual_discharge_date.toggle()" type="button">
													<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
												</button>
											</div>
											<p *ngIf="showError('actual_discharge_date')" class="text-danger">
												<span *ngIf="f.actual_discharge_date.errors?.required">
													Required
												</span>
												<span *ngIf="f.actual_discharge_date.errors?.incorrect">
													{{customError.actual_discharge_date}}
												</span>
											</p>
										</div>
										}
										@if(showDischargedFields){
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
											<label>Ambulance Required:</label>
											<br />
											<mat-radio-group formControlName="is_ambulance_needed"
												id="is_ambulance_needed">
												<mat-radio-button [value]="true" [color]="'primary'">
													Yes
												</mat-radio-button>
												<mat-radio-button [value]="false" [color]="'primary'">
													No
												</mat-radio-button>
											</mat-radio-group>
											<p *ngIf="showError('is_ambulance_needed')" class="text-danger">
												<span *ngIf="f.is_ambulance_needed.errors?.required">
													Required
												</span>
												<span *ngIf="f.is_ambulance_needed.errors?.incorrect">
													{{customError.is_ambulance_needed}}
												</span>
											</p>
										</div>
										}
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12"
											*ngIf="showAdmittedFields || showPreAdmittedFields || showDayCareFields">
											<div class="form-floating">
												<input class="form-control"
													[ngClass]="{'is-invalid':showError('expected_days')}"
													id="expected_days" formControlName="expected_days" placeholder="">
												<label for="expected_days">Expected Days</label>
											</div>
											<p *ngIf="showError('expected_days')" class="text-danger">
												<span *ngIf="f.expected_days.errors?.required">
													Required
												</span>
												<span *ngIf="f.expected_days.errors?.pattern">
													Invalid
												</span>
												<span *ngIf="f.expected_days.errors?.incorrect">
													{{customError.expected_days}}
												</span>
											</p>
										</div>
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3"
											*ngIf="showAdmittedFields || showPreAdmittedFields || showDayCareFields">
											<ng-select [ngClass]="{'is-invalid':showError('surgery_status_id')}"
												[items]="parent.surgeryStatusList" bindLabel="name" bindValue="id"
												[clearable]="true" id="surgery_status_id"
												formControlName="surgery_status_id" placeholder="Surgery"
												[appearance]="'outline'" (change)="surgeryChanged()">
											</ng-select>
											<p *ngIf="showError('surgery_status_id')" class="text-danger">
												<span *ngIf="f.surgery_status_id.errors?.required">
													Required
												</span>
												<span *ngIf="f.surgery_status_id.errors?.incorrect">
													{{customError.surgery_status_id}}
												</span>
											</p>
										</div>
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3"
											*ngIf="showAdmittedFields || showPreAdmittedFields || showDayCareFields">
											<div class="input-group">
												<div class="form-floating">
													<input class="form-control"
														[ngClass]="{'is-invalid':showError('actual_surgery_date')}"
														placeholder="" formControlName="actual_surgery_date"
														ngbDatepicker id="actual_surgery_date"
														#actual_surgery_date="ngbDatepicker" [minDate]="minDate"
														[container]="'body'" />
													<label for="actual_surgery_date">
														Surgery Date
														@if(isRequired('actual_surgery_date')){
														*
														}
													</label>
												</div>
												<button class="btn btn-outline-secondary"
													(click)="actual_surgery_date.toggle()" type="button">
													<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
												</button>
											</div>
											<p *ngIf="showError('actual_surgery_date')" class="text-danger">
												<span *ngIf="f.actual_surgery_date.errors?.required">
													Required
												</span>
												<span *ngIf="f.actual_surgery_date.errors?.incorrect">
													{{customError.actual_surgery_date}}
												</span>
											</p>
										</div>
									</div>
								</td>
							</tr>
							}
							<tr *ngIf="showPhysiotherapyFields" @fadeInOut>
								<td>
									<h5 class="fw-bold mb-2">Physiotherapy Details:</h5>
									<!-- <div class="row mb-3">
											<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<div class="input-group">
													<div class="form-floating">
														<input class="form-control"
															[ngClass]="{'is-invalid':showError('physiotherapy_date')}"
															placeholder="" formControlName="physiotherapy_date" ngbDatepicker
															id="physiotherapy_date" #physiotherapy_date="ngbDatepicker"
															[minDate]="minDate" [container]="'body'" />
														<label for="physiotherapy_date">Start Date</label>
													</div>
													<button class="btn btn-outline-secondary"
														(click)="physiotherapy_date.toggle()" type="button">
														<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
													</button>
												</div>
												<p *ngIf="showError('physiotherapy_date')" class="text-danger">
													<span *ngIf="f.physiotherapy_date.errors?.required">
														Required
													</span>
													<span *ngIf="f.physiotherapy_date.errors?.incorrect">
														{{customError.physiotherapy_date}}
													</span>
												</p>
											</div>
											<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<div class="input-group">
													<div class="form-floating">
														<input class="form-control"
															[ngClass]="{'is-invalid':showError('physiotherapy_end_date')}"
															placeholder="" formControlName="physiotherapy_end_date"
															ngbDatepicker id="physiotherapy_end_date"
															#physiotherapy_end_date="ngbDatepicker" [minDate]="minDate"
															[container]="'body'" />
														<label for="physiotherapy_end_date">End Date</label>
													</div>
													<button class="btn btn-outline-secondary"
														(click)="physiotherapy_end_date.toggle()" type="button">
														<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
													</button>
												</div>
												<p *ngIf="showError('physiotherapy_end_date')" class="text-danger">
													<span *ngIf="f.physiotherapy_end_date.errors?.required">
														Required
													</span>
													<span *ngIf="f.physiotherapy_end_date.errors?.incorrect">
														{{customError.physiotherapy_end_date}}
													</span>
												</p>
											</div>
											<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<div class="form-floating">
													<input class="form-control"
														[ngClass]="{'is-invalid':showError('physiotherapy_session_counts')}"
														id="physiotherapy_session_counts"
														formControlName="physiotherapy_session_counts" placeholder="">
													<label for="physiotherapy_session_counts">Session Counts</label>
												</div>
												<p *ngIf="showError('physiotherapy_session_counts')" class="text-danger">
													<span *ngIf="f.physiotherapy_session_counts.errors?.required">
														Required
													</span>
													<span *ngIf="f.physiotherapy_session_counts.errors?.pattern">
														Invalid
													</span>
													<span *ngIf="f.physiotherapy_session_counts.errors?.incorrect">
														{{customError.physiotherapy_session_counts}}
													</span>
												</p>
											</div>
										</div> -->
									<div class="row mb-3">
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
											<div class="form-floating">
												<input class="form-control"
													[ngClass]="{'is-invalid':showError('physiotherapy_percentage')}"
													id="physiotherapy_percentage"
													formControlName="physiotherapy_percentage" placeholder="">
												<label for="physiotherapy_percentage">% Imp.</label>
											</div>
											<p *ngIf="showError('physiotherapy_percentage')" class="text-danger">
												<span *ngIf="f.physiotherapy_percentage.errors?.required">
													Required
												</span>
												<span *ngIf="f.physiotherapy_percentage.errors?.pattern">
													Invalid
												</span>
												<span *ngIf="f.physiotherapy_percentage.errors?.incorrect">
													{{customError.physiotherapy_percentage}}
												</span>
											</p>
										</div>
										<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
											<div class="form-floating">
												<input class="form-control"
													[ngClass]="{'is-invalid':showError('physiotherapy_notes')}"
													id="physiotherapy_notes" formControlName="physiotherapy_notes"
													placeholder="">
												<label for="physiotherapy_notes">Physiotherapy Notes</label>
											</div>
											<p *ngIf="showError('physiotherapy_notes')" class="text-danger">
												<span *ngIf="f.physiotherapy_notes.errors?.required">
													Required
												</span>
												<span *ngIf="f.physiotherapy_notes.errors?.incorrect">
													{{customError.physiotherapy_notes}}
												</span>
											</p>
										</div>
									</div>
								</td>
							</tr>
							<!-- <tr *ngIf="!showNonMedicalFields" @fadeInOut>
									<td>
										<h5 class="fw-bold mb-2">Disability Details:</h5>
										<div class="row mb-3">
											<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<ng-select [ngClass]="{'is-invalid':showError('disability_status_id')}"
													[items]="parent.disablityStatusList" bindLabel="name" bindValue="id"
													[clearable]="true" id="disability_status_id"
													formControlName="disability_status_id" placeholder="Disability"
													[appearance]="'outline'">
												</ng-select>
												<p *ngIf="showError('disability_status_id')" class="text-danger">
													<span *ngIf="f.disability_status_id.errors?.required">
														Required
													</span>
													<span *ngIf="f.disability_status_id.errors?.incorrect">
														{{customError.disability_status_id}}
													</span>
												</p>
											</div>
											<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<div class="form-floating">
													<input class="form-control"
														[ngClass]="{'is-invalid':showError('disability_per')}"
														id="disability_per" formControlName="disability_per" placeholder="">
													<label for="disability_per">Disability %</label>
												</div>
												<p *ngIf="showError('disability_per')" class="text-danger">
													<span *ngIf="f.disability_per.errors?.required">
														Required
													</span>
													<span *ngIf="f.disability_per.errors?.pattern">
														Invalid
													</span>
													<span *ngIf="f.disability_per.errors?.incorrect">
														{{customError.disability_per}}
													</span>
												</p>
											</div>
											<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<div class="form-floating">
													<input class="form-control"
														[ngClass]="{'is-invalid':showError('disability_notes')}"
														id="disability_notes" formControlName="disability_notes" placeholder="">
													<label for="disability_notes">Disability Notes</label>
												</div>
												<p *ngIf="showError('disability_notes')" class="text-danger">
													<span *ngIf="f.disability_notes.errors?.required">
														Required
													</span>
													<span *ngIf="f.disability_notes.errors?.incorrect">
														{{customError.disability_notes}}
													</span>
												</p>
											</div>
										</div>
									</td>
								</tr> -->
							@if (!showNonMedicalFields) {
							<tr @fadeInOut>
								<td>
									<h5 class="fw-bold mb-2">Hospital/Doctor Details:</h5>
									<div class="row mb-3">
										@if(!showTeleConsultsFields){
										<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" @fadeInOut>
											<ng-select [ngClass]="{'is-invalid':showError('dropoff_hospital_id')}"
												[items]="hospitalList" bindLabel="name" bindValue="id"
												[clearable]="true" id="dropoff_hospital_id"
												formControlName="dropoff_hospital_id" placeholder="Medical Center"
												[appearance]="'outline'" (change)="getDoctorList()">
											</ng-select>
											<p *ngIf="showError('dropoff_hospital_id')" class="text-danger">
												<span *ngIf="f.dropoff_hospital_id.errors?.required">
													Required
												</span>
												<span *ngIf="f.dropoff_hospital_id.errors?.incorrect">
													{{customError.dropoff_hospital_id}}
												</span>
											</p>
										</div>
										}
										<!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
												<mat-checkbox [color]="'primary'" formControlName="is_specialist_consulted"
													id="is_specialist_consulted">
													Is Specialist Connected
												</mat-checkbox>
											</div> -->
										<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
											<ng-select [ngClass]="{'is-invalid':showError('opd_doctor_id')}"
												[items]="doctorList" bindLabel="name" bindValue="id" [clearable]="true"
												id="opd_doctor_id" formControlName="opd_doctor_id" placeholder="Doctor"
												[appearance]="'outline'">
											</ng-select>
											<p *ngIf="showError('opd_doctor_id')" class="text-danger">
												<span *ngIf="f.opd_doctor_id.errors?.required">
													Required
												</span>
												<span *ngIf="f.opd_doctor_id.errors?.incorrect">
													{{customError.opd_doctor_id}}
												</span>
											</p>
										</div>
									</div>
								</td>
							</tr>
							}
							<tr>
								<td>
									<div class="row mb-3">
										<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
											<label class="form-label">
												Notes:
												<ng-container *ngIf="followUpDetails?.is_handover_done">
													<strong class="ms-3">
														Handover Done
														<fa-icon [icon]="['fas','check']"
															class="text-success"></fa-icon>
													</strong>
												</ng-container>
											</label>
											<quill-editor id="opd_notes" formControlName="opd_notes"
												[modules]="quillConfig" [placeholder]="'Notes'"></quill-editor>
											<p *ngIf="showError('opd_notes')" class="text-danger">
												<span *ngIf="f.opd_notes.errors?.required">
													Required
												</span>
												<span *ngIf="f.opd_notes.errors?.incorrect">
													{{customError.opd_notes}}
												</span>
											</p>
										</div>
									</div>
								</td>
							</tr>
							<tr *ngIf="!showNonMedicalFields" @fadeInOut>
								<td>
									<div class="row mb-3">
										<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
											<label>Consultation Fees:</label>
											<br />
											<mat-radio-group formControlName="is_payment_needed" id="is_payment_needed">
												<mat-radio-button [value]="true" [color]="'primary'">
													Yes
												</mat-radio-button>
												<mat-radio-button [value]="false" [color]="'primary'">
													No
												</mat-radio-button>
											</mat-radio-group>
											<p *ngIf="showError('is_payment_needed')" class="text-danger">
												<span *ngIf="f.is_payment_needed.errors?.required">
													Required
												</span>
												<span *ngIf="f.is_payment_needed.errors?.incorrect">
													{{customError.is_payment_needed}}
												</span>
											</p>
										</div>
										<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
											*ngIf="!showTeleConsultsFields" @fadeInOut>
											<label>Is Travel Needed:</label>
											<br />
											<mat-radio-group formControlName="travel_needed" id="travel_needed">
												<!-- <mat-radio-button [value]="true" [color]="'primary'">
														Yes
													</mat-radio-button>
													<mat-radio-button [value]="false" [color]="'primary'">
														No
													</mat-radio-button> -->
												<mat-radio-button [value]="0" [color]="'primary'">
													No
												</mat-radio-button>
												<mat-radio-button [value]="1" [color]="'primary'">
													Oneway
												</mat-radio-button>
												<mat-radio-button [value]="2" [color]="'primary'">
													Round Trip
												</mat-radio-button>
											</mat-radio-group>
											<p *ngIf="showError('travel_needed')" class="text-danger">
												<span *ngIf="f.travel_needed.errors?.required">
													Required
												</span>
												<span *ngIf="f.travel_needed.errors?.incorrect">
													{{customError.travel_needed}}
												</span>
											</p>
										</div>
										<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<label>Medical Notes:</label>
											<br />
											<mat-radio-group formControlName="medical_prescription"
												id="medical_prescription">
												<mat-radio-button [value]="true" [color]="'primary'">
													Yes
												</mat-radio-button>
												<mat-radio-button [value]="false" [color]="'primary'">
													No
												</mat-radio-button>
											</mat-radio-group>
											<p *ngIf="showError('medical_prescription')" class="text-danger">
												<span *ngIf="f.medical_prescription.errors?.required">
													Required
												</span>
												<span *ngIf="f.medical_prescription.errors?.incorrect">
													{{customError.medical_prescription}}
												</span>
											</p>
										</div>
										<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
											*ngIf="showTeleConsultsFields">
											<div class="form-floating">
												<input class="form-control"
													[ngClass]="{'is-invalid':showError('amount')}" id="amount"
													formControlName="amount" placeholder="">
												<label for="amount">Amount</label>
											</div>
											<p *ngIf="showError('amount')" class="text-danger">
												<span *ngIf="f.amount.errors?.required">
													Required
												</span>
												<span *ngIf="f.amount.errors?.pattern">
													Invalid
												</span>
												<span *ngIf="f.amount.errors?.incorrect">
													{{customError.amount}}
												</span>
											</p>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<td>
									<div class="row mb-3">
										@if(!isHandoverAfterClosed){
										<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<ng-select [ngClass]="{'is-invalid':showError('status3_id')}"
												[items]="parent.status3List" bindLabel="name" bindValue="id"
												id="status3_id" formControlName="status3_id" placeholder="Status 3*"
												[appearance]="'outline'" [clearable]="true">
											</ng-select>
											<p *ngIf="showError('status3_id')" class="text-danger">
												<span *ngIf="f.status3_id.errors?.required">
													Required
												</span>
												<span *ngIf="f.status3_id.errors?.incorrect">
													{{customError.status3_id}}
												</span>
											</p>
										</div>
										}
										<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
											@if(!isHandoverAfterClosed){
											<label><strong>Follow-up Status:</strong></label>
											<br />
											<mat-radio-group formControlName="follow_up_status_id"
												id="follow_up_status_id" (change)="followupStatusChanged(true)">
												<mat-radio-button *ngFor="let status of parent.followUpStatusList"
													[value]="status.id" [color]="'primary'">
													{{status.name}}
												</mat-radio-button>
											</mat-radio-group>
											}
											@if(navbar.userAccess?.Follow_up=='Full'){
											@if(!isFollowupClosed && parent.caseDetails?.status != 2){
											<button type="button" class="btn btn-sm btn-success ms-1"
												(click)="openNewFollowupModal(false)">
												New Follow-up
											</button>
											}@else{
											<button type="button" class="btn btn-sm btn-success ms-1"
												(click)="openNewFollowupModal(true)">
												New Non-Medical Follow-up
											</button>
											}
											}
											@if(showOPDFields || showIPDFields || showPhysiotherapyFields){
											<button type="button" class="btn btn-sm btn-primary ms-1"
												(click)="getReferralFile()" matTooltip="Referral File">
												<fa-icon *ngIf="!referralDownloadLoader"
													[icon]="['fas', 'cloud-download-alt']"></fa-icon>
												<fa-icon *ngIf="referralDownloadLoader" [icon]="['fas', 'spinner']"
													animation="spin"></fa-icon>
											</button>
											}
											<p *ngIf="showError('follow_up_status_id')" class="text-danger">
												<span *ngIf="f.follow_up_status_id.errors?.required">
													Required
												</span>
												<span *ngIf="f.follow_up_status_id.errors?.incorrect">
													{{customError.follow_up_status_id}}
												</span>
											</p>
										</div>
									</div>
								</td>
							</tr>
							<tr *ngIf="showCompletedFields" @fadeInOut>
								<td>
									<h5 class="fw-bold mb-2">Next Follow-up Details:</h5>
									<div class="row mb-3">
										<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<div class="input-group">
												<div class="form-floating">
													<input class="form-control"
														[ngClass]="{'is-invalid':showError('next_follow_up_date')}"
														placeholder="" formControlName="next_follow_up_date"
														ngbDatepicker id="next_follow_up_date"
														#next_follow_up_date="ngbDatepicker" [minDate]="minDate"
														[container]="'body'" />
													<label for="next_follow_up_date">Next Follow-up</label>
												</div>
												<button class="btn btn-outline-secondary"
													(click)="next_follow_up_date.toggle()" type="button">
													<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
												</button>
											</div>
											<p *ngIf="showError('next_follow_up_date')" class="text-danger">
												<span *ngIf="f.next_follow_up_date.errors?.required">
													Required
												</span>
												<span *ngIf="f.next_follow_up_date.errors?.incorrect">
													{{customError.next_follow_up_date}}
												</span>
											</p>
										</div>
										<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<ng-select [ngClass]="{'is-invalid':showError('next_visit_type_id')}"
												[items]="parent.allVisitType" bindLabel="name" bindValue="id"
												[clearable]="true" id="next_visit_type_id"
												formControlName="next_visit_type_id" placeholder="Appointment Type"
												[appearance]="'outline'">
												<ng-template ng-label-tmp let-item="item">
													<img src="../../assets/img/appt-types/{{parent.appt_type_images[item.name]}}"
														class="appt-type-img" />
													{{item.name}}
												</ng-template>
												<ng-template ng-option-tmp let-item="item" let-search="searchTerm"
													let-index="index">
													<img src="../../assets/img/appt-types/{{parent.appt_type_images[item.name]}}"
														class="appt-type-img" />
													{{item.name}}
												</ng-template>
											</ng-select>
											<p *ngIf="showError('next_visit_type_id')" class="text-danger">
												<span *ngIf="f.next_visit_type_id.errors?.required">
													Required
												</span>
												<span *ngIf="f.next_visit_type_id.errors?.incorrect">
													{{customError.next_visit_type_id}}
												</span>
											</p>
										</div>
									</div>
								</td>
							</tr>
							<!-- <tr *ngIf="showClosureFields" @fadeInOut>
									<td>
										<div class="row mb-2">
											<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<ng-select [ngClass]="{'is-invalid':showError('status4_id')}"
													[items]="parent.status4List" bindLabel="name" bindValue="id"
													[clearable]="true" id="status4_id" formControlName="status4_id"
													placeholder="Closure Status*" [appearance]="'outline'">
												</ng-select>
												<p *ngIf="showError('status4_id')" class="text-danger">
													<span *ngIf="f.status4_id.errors?.required">
														Required
													</span>
													<span *ngIf="f.status4_id.errors?.incorrect">
														{{customError.status4_id}}
													</span>
												</p>
											</div>
										</div>
										<div class="row mb-2">
											<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label class="form-label">Closure Notes*:</label>
												<quill-editor id="closure_notes" formControlName="closure_notes"
													[modules]="quillConfig" [placeholder]="'Notes'"></quill-editor>
												<p *ngIf="showError('closure_notes')" class="text-danger">
													<span *ngIf="f.closure_notes.errors?.required">
														Required
													</span>
													<span *ngIf="f.closure_notes.errors?.incorrect">
														{{customError.closure_notes}}
													</span>
												</p>
											</div>
										</div>
									</td>
								</tr> -->
							<tr>
								<td>
									<div class="row mb-3">
										<div class="col">
											@if (navbar.userAccess?.Follow_up=='Full') {
											<button type="submit" class="btn btn-sm btn-success me-1"
												[disabled]="!moduleForm.dirty || showLoader">
												<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
												<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']"
													animation="spin"></fa-icon>
												Submit
											</button>
											}
											@if (
											(navbar.userAccess?.Follow_up_report=='Full' ||
											navbar.userAccess?.Follow_up_report=='Readonly') &&
											(isFollowupCompleted || isFollowupClosed) &&
											!isHandoverAfterClosed
											) {
											<a class="btn btn-sm btn-primary me-1"
												[routerLink]="['/app/send-report',uId,followupId]">
												<fa-icon [icon]="['fas', 'file-pdf']"></fa-icon>
												Report
											</a>
											}
											<!-- <button type="button" class="btn btn-sm btn-primary me-1"
												(click)="openTreatmentModal();">
												Quotation
											</button> -->
											@if(treat_costs.length){
											<app-treatment-cost-form [id]="treat_costs[0]?.enc_id" [btn_type]="1"
												class="me-1" (created)="getTreatmentCosts()">
											</app-treatment-cost-form>
											}@else{
											<app-treatment-cost-form [followupId]="followUpDetails?.id" [btn_type]="1"
												class="me-1" (created)="getTreatmentCosts()"
												[icd_code_name]="parent.caseDetails?.icd_code">
											</app-treatment-cost-form>
											}
											<a class="btn btn-sm btn-primary me-1"
												[routerLink]="['/app/followup-fct',uId,followupId]">
												FCT Form
											</a>
											@if (
											(isFollowupCompleted || isFollowupClosed) &&
											!isHandoverAfterClosed
											){
											<mat-checkbox [color]="'primary'" formControlName="followup_report_sent"
												(change)="reportSentChanged()" id="followup_report_sent" class="me-2">
												Report sent
												@if (rep_sent_loader) {
												<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
												}
											</mat-checkbox>
											@if(f.followup_report_sent.value){
											<span class="small">
												Updated by
												<strong>
													{{followUpDetails?.followup_report_sent_by}}
												</strong>
												at
												<strong>
													{{followUpDetails?.followup_report_sent_date}}
												</strong>
											</span>
											}
											}
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</form>
			</div>
		</div>
	</div>
</div>
}
@if(
!pageLoading2 &&
(navbar.userAccess?.Follow_up=='Full' || navbar.userAccess?.Follow_up=='Readonly') &&
(navbar.userAccess?.Billing=='Full' || navbar.userAccess?.Billing=='Readonly')
){
<div class="card" @fadeInOut>
	<div class="card-header">
		<h5 style="font-size: 12px !important;" class="card-title text-dark mb-0">
			Billing
			<fa-icon [icon]="['fas', 'edit']" class="float-end" role="button" matTooltip="Edit"
				(click)="openBillModal()" *ngIf="navbar.userAccess?.Billing=='Full'">
			</fa-icon>
		</h5>
	</div>
	<div class="card-body">
		<table class="table table-bordered less-padding">
			<thead>
				<tr>
					<th style="width: 15% !important;">Date</th>
					<th style="width: 10% !important;">Category</th>
					<th style="width: 10% !important;">Notes</th>
					<th style="width: 10% !important;">Amount</th>
					<th style="width: 10% !important;">Files</th>
					<th style="width: 10% !important;">QR Code</th>
					<th style="width: 10% !important;">Gpay</th>
					<th style="width: 8% !important;">Paid</th>
					<th style="width: 8% !important;">Approval</th>
					<th style="width: 9% !important;">Reimbursement</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let bill of followUpBillsData;let i = index;">
					<tr [ngClass]="{ 'orange': !bill.files || bill.files.length==0 }">
						<td>
							{{bill.date}}
						</td>
						<td>
							<!-- {{getBillCatName(bill.category)}} -->
							{{bill.category_name}}
						</td>
						<td>
							{{bill.notes}}
						</td>
						<td>
							{{bill.amount}}
						</td>
						<td>
							<ng-container *ngIf="bill.files">
								<div *ngFor="let file of bill.files;let j = index;" class="icon-container no-delete">
									<file-icon [file]="file"></file-icon>
								</div>
							</ng-container>
						</td>
						<td>
							<ng-container *ngIf="bill.qrcode_files">
								<div *ngFor="let file of bill.qrcode_files;let j = index;"
									class="icon-container no-delete">
									<file-icon [file]="file"></file-icon>
								</div>
							</ng-container>
						</td>
						<td>
							<ng-container *ngIf="bill.gpay_files">
								<div *ngFor="let file of bill.gpay_files;let j = index;"
									class="icon-container no-delete">
									<file-icon [file]="file"></file-icon>
								</div>
							</ng-container>
						</td>
						<td>
							<fa-icon *ngIf="bill.is_paid" [icon]="['fas', 'check']" class="text-success"></fa-icon>
						</td>
						<td>
							<fa-icon *ngIf="bill.is_approved" [icon]="['fas', 'check']" class="text-success"></fa-icon>
						</td>
						<td>
							<fa-icon *ngIf="bill.reimbursement" [icon]="['fas', 'check']"
								class="text-success"></fa-icon>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
</div>
}
<div class="modal fade" id="billingModalFollowup" role="dialog">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>Billing</strong></h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				@if (parent.selectedAttachments.length && parent.selectedAttType=="bill") {
				<div class="row">
					<div class="col">
						<view-attachments [attachmentsArr]="parent.selectedAttachments" [showDelete]="true">
						</view-attachments>
					</div>
				</div>
				<div class="row mb-1">
					<div class="col">
						<button type="button" class="btn btn-xs btn-warning"
							(click)="parent.clearSelectedAttachments()">
							Cancel adding attachment
						</button>
					</div>
				</div>
				}
				<div class="row mb-3">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<table class="table table-bordered less-padding">
							<thead>
								<tr>
									<th style="width: 15% !important;">Date</th>
									<th style="width: 10% !important;">Category</th>
									<th style="width: 15% !important;">Notes</th>
									<th style="width: 10% !important;">Amount</th>
									<th style="width: 10% !important;">Files</th>
									<th style="width: 10% !important;">QR Code</th>
									<th style="width: 10% !important;">Gpay</th>
									<th style="width: 5% !important;">Paid</th>
									<th style="width: 5% !important;">Approval</th>
									<th style="width: 5% !important;">Reimbursement</th>
									<th style="width: 5% !important;">Action</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let bill of billingDetailsForEdit;let i = index;">
									<tr [ngClass]="{ 'orange': !bill.files || bill.files.length==0 }">
										<td>
											<input class="form-control" [(ngModel)]="bill.date" ngbDatepicker
												#date="ngbDatepicker" [minDate]="minDate" [maxDate]="billingMaxDate"
												(click)="date.toggle()" [disabled]="bill.used_in_invoice" />
										</td>
										<td>
											<ng-select [items]="parent.billCategoryList" bindLabel="name" bindValue="id"
												[disabled]="bill.used_in_invoice" [clearable]="false"
												placeholder="Category" [(ngModel)]="bill.category" appearance="outline">
											</ng-select>
										</td>
										<td>
											<input type="text" class="form-control" [readonly]="bill.used_in_invoice"
												[(ngModel)]="bill.notes" />
										</td>
										<td>
											<input type="number" class="form-control" [readonly]="bill.used_in_invoice"
												[(ngModel)]="bill.amount" (ngModelChange)="getBillingTotal();" />
										</td>
										<td>
											<div class="row g-0">
												<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
													<app-file-upload [allowedFiles]="allowedBillFiles"
														[uploadFolder]="'follow_up_bills'"
														(uploaded)="billFileUploaded($event,i)" [flag]="true">
													</app-file-upload>
												</div>
												<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 ps-0">
													<ng-container *ngIf="bill.files">
														<div *ngFor="let file of bill.files;let j = index;"
															class="icon-container">
															<file-icon [file]="file"
																(amountFetched)="amountFetched($event,i)"
																[isReceipt]="true"></file-icon>
															<fa-icon [icon]="['fas', 'times-circle']"
																class="delete-icon text-danger" matTooltip="Delete"
																(click)="deleteBillFile(file,i,j);"></fa-icon>
														</div>
													</ng-container>
												</div>
											</div>
											@if (parent.selectedAttachments.length && parent.selectedAttType=="bill"){
											<div class="row g-0">
												<div class="col">
													<button matTooltip="Add attachments here" type="button"
														class="btn btn-xs btn-success"
														[disabled]="disableBillFileAtt(i)"
														(click)="addMailAttachments(i,'bill_file');">
														@if(disableBillFileAtt(i)){
														<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'">
														</fa-icon>
														}@else{
														<fa-icon [icon]="['fas', 'paperclip']">
														</fa-icon>
														}
													</button>
												</div>
											</div>
											}
										</td>
										<td>
											<div class="row g-0">
												<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
													<app-file-upload [allowedFiles]="allowedBillQRFiles"
														[uploadFolder]="'follow_up_bills'"
														(uploaded)="qrFileUploaded($event,i)">
													</app-file-upload>
												</div>
												<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 ps-0">
													<ng-container *ngIf="bill.qrcode_files">
														<div *ngFor="let file of bill.qrcode_files;let j = index;"
															class="icon-container">
															<file-icon [file]="file"></file-icon>
															<fa-icon [icon]="['fas', 'times-circle']"
																class="delete-icon text-danger" matTooltip="Delete"
																(click)="deleteBillQRFile(file,i,j);"></fa-icon>
														</div>
													</ng-container>
												</div>
											</div>
										</td>
										<td>
											<div class="row g-0">
												<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
													<app-file-upload [allowedFiles]="allowedBillGPayFiles"
														[uploadFolder]="'follow_up_bills'"
														(uploaded)="gpayFileUploaded($event,i)">
													</app-file-upload>
												</div>
												<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 ps-0">
													<ng-container *ngIf="bill.gpay_files">
														<div *ngFor="let file of bill.gpay_files;let j = index;"
															class="icon-container">
															<file-icon [file]="file"
																(amountFetched)="amountFetched($event,i)"
																[isReceipt]="true"></file-icon>
															<fa-icon [icon]="['fas', 'times-circle']"
																class="delete-icon text-danger" matTooltip="Delete"
																(click)="deleteBillGpayFile(file,i,j);"></fa-icon>
														</div>
													</ng-container>
												</div>
											</div>
											@if (parent.selectedAttachments.length && parent.selectedAttType=="bill"){
											<div class="row g-0">
												<div class="col">
													<button matTooltip="Add attachments here" type="button"
														class="btn btn-xs btn-success"
														[disabled]="disableBillGPayAtt(i)"
														(click)="addMailAttachments(i,'gpay');">
														@if(disableBillGPayAtt(i)){
														<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'">
														</fa-icon>
														}@else{
														<fa-icon [icon]="['fas', 'paperclip']">
														</fa-icon>
														}
													</button>
												</div>
											</div>
											}
										</td>
										<td>
											<!-- <ng-toggle [(ngModel)]="bill.is_paid"
												[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
												[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
												[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
												[labels]="{'unchecked': 'Unpaid','checked': 'Paid'}" [width]="90"
												[disabled]="bill.used_in_invoice"></ng-toggle> -->
											<mat-checkbox [color]="'primary'" [(ngModel)]="bill.is_paid"></mat-checkbox>
										</td>
										<td>
											<!-- <ng-toggle [(ngModel)]="bill.is_approved"
												[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
												[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
												[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
												[labels]="{'unchecked': 'Pending','checked': 'Approved'}" [width]="90"
												[disabled]="bill.used_in_invoice"></ng-toggle> -->
											<mat-checkbox [color]="'primary'"
												[(ngModel)]="bill.is_approved"></mat-checkbox>
										</td>
										<td>
											<!-- <ng-toggle [(ngModel)]="bill.reimbursement"
												[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
												[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
												[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
												[labels]="{'unchecked': 'Pending','checked': 'Done'}" [width]="90"
												[disabled]="bill.used_in_invoice"></ng-toggle> -->
											<mat-checkbox [color]="'primary'"
												[(ngModel)]="bill.reimbursement"></mat-checkbox>
										</td>
										<td>
											<button matTooltip="Delete" type="button" [disabled]="bill.used_in_invoice"
												class="btn btn-xs btn-danger" (click)="removeBillingDetails(i);">
												<fa-icon [icon]="['fas', 'times']"></fa-icon>
											</button>
											<button matTooltip="Save" type="button"
												[disabled]="saveBillLoaderSingle == i"
												class="btn btn-xs btn-success ms-1" (click)="saveSingleBilling(i);">
												@if(saveBillLoaderSingle == i){
												<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
												}@else{
												<fa-icon [icon]="['fas', 'save']"></fa-icon>
												}
											</button>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-primary float-start" (click)="addBillingDetails()">
					<fa-icon [icon]="['fas', 'plus']"></fa-icon>
					Add Billing
				</button>
				<button type="button" class="btn btn-sm btn-success" (click)="saveBilling()"
					[disabled]="saveBillLoader">
					<fa-icon *ngIf="saveBillLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!saveBillLoader" [icon]="['fas', 'save']"></fa-icon>
					Save
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
@if(
!pageLoading3 &&
(navbar.userAccess?.Follow_up=='Full' || navbar.userAccess?.Follow_up=='Readonly')
){
<div class="card" @fadeInOut>
	<div class="card-header">
		<h5 style="font-size: 12px !important;" class="card-title text-dark mb-0">
			Files
			<fa-icon [icon]="['fas', 'edit']" class="float-end" role="button" matTooltip="Edit"
				(click)="openFileModal()" *ngIf="navbar.userAccess?.Follow_up=='Full'">
			</fa-icon>
		</h5>
	</div>
	<div class="card-body">
		<table class="table table-bordered less-padding">
			<thead>
				<tr>
					<th style="width: 20% !important;">Name</th>
					<th style="width: 80% !important;">Files</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let bill of followupFiles;let i = index;">
					<tr [ngClass]="{ 'orange': !bill.file_url || bill.file_url.length==0 }">
						<td>
							{{bill.file_name}}
						</td>
						<td>
							<ng-container *ngIf="bill.file_url">
								<div *ngFor="let file of bill.file_url;let j = index;" class="icon-container no-delete">
									<file-icon [file]="file"></file-icon>
								</div>
							</ng-container>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
</div>
<div class="card" @fadeInOut>
	<div class="card-header">
		<h5 style="font-size: 12px !important;" class="card-title text-dark mb-0">
			Additional Files
			<fa-icon [icon]="['fas', 'edit']" class="float-end" role="button" matTooltip="Edit"
				(click)="openAdditionalFileModal()" *ngIf="navbar.userAccess?.Follow_up=='Full'">
			</fa-icon>
		</h5>
	</div>
	<div class="card-body">
		<table class="table table-bordered less-padding">
			<thead>
				<tr>
					<th style="width: 20% !important;">Name</th>
					<th style="width: 80% !important;">Files</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let bill of followupAdditionalFiles;let i = index;">
					<tr [ngClass]="{ 'orange': !bill.file_url || bill.file_url.length==0 }">
						<td>
							{{bill.file_name}}
						</td>
						<td>
							<ng-container *ngIf="bill.file_url">
								<div *ngFor="let file of bill.file_url;let j = index;" class="icon-container no-delete">
									<file-icon [file]="file"></file-icon>
								</div>
							</ng-container>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
</div>
}
<div class="modal fade" id="fileModal" role="dialog">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>Files</strong></h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				@if (parent.selectedAttachments.length && parent.selectedAttType=="file") {
				<div class="row">
					<div class="col">
						<view-attachments [attachmentsArr]="parent.selectedAttachments" [showDelete]="true">
						</view-attachments>
					</div>
				</div>
				<div class="row mb-1">
					<div class="col">
						<button type="button" class="btn btn-xs btn-warning"
							(click)="parent.clearSelectedAttachments()">
							Cancel adding attachment
						</button>
					</div>
				</div>
				}
				<div class="row mb-3">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<table class="table table-bordered less-padding">
							<thead>
								<tr>
									<th style="width: 25% !important;">Name</th>
									<th style="width: 70% !important;">Files</th>
									<th style="width: 5% !important;">Action</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let bill of followupFilesForEdit;let i = index;">
									<tr [ngClass]="{ 'orange': !bill.file_url || bill.file_url.length==0 }">
										<td>
											<input type="text" class="form-control" [(ngModel)]="bill.file_name" />
										</td>
										<td>
											<div class="row g-0">
												<div class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
													<app-file-upload [allowedFiles]="allowedFiles"
														[uploadFolder]="'follow_up_files'"
														(uploaded)="followUpFileUploaded($event,i)">
													</app-file-upload>
												</div>
												<div class="col-lg-11 col-md-11 col-sm-12 col-xs-12 ps-0">
													<ng-container *ngIf="bill.file_url">
														<div *ngFor="let file of bill.file_url;let j = index;"
															class="icon-container">
															<file-icon [file]="file"></file-icon>
															<fa-icon [icon]="['fas', 'times-circle']"
																class="delete-icon text-danger" matTooltip="Delete"
																(click)="deleteFollowupFile(file,i,j);"></fa-icon>
														</div>
													</ng-container>
												</div>
											</div>
											@if (parent.selectedAttachments.length && parent.selectedAttType=="file"){
											<div class="row g-0">
												<div class="col">
													<button matTooltip="Add attachments here" type="button"
														class="btn btn-xs btn-success" [disabled]="disableFileAtt(i)"
														(click)="addMailAttachments(i,'file');">
														@if(disableFileAtt(i)){
														<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'">
														</fa-icon>
														}@else{
														<fa-icon [icon]="['fas', 'paperclip']">
														</fa-icon>
														}
													</button>
												</div>
											</div>
											}
										</td>
										<td>
											<button matTooltip="Delete" type="button" class="btn btn-sm btn-danger"
												(click)="removeFileDetails(i);">
												<fa-icon [icon]="['fas', 'times']"></fa-icon>
											</button>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-primary float-start" (click)="addFiles()">
					<fa-icon [icon]="['fas', 'plus']"></fa-icon>
					Add Files
				</button>
				<button type="button" class="btn btn-sm btn-success" (click)="saveFiles()" [disabled]="saveFileLoader">
					<fa-icon *ngIf="saveFileLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!saveFileLoader" [icon]="['fas', 'save']"></fa-icon>
					Save
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="additionalFileModal" role="dialog">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>Additional Files</strong></h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				@if (parent.selectedAttachments.length && parent.selectedAttType=="file") {
				<div class="row">
					<div class="col">
						<view-attachments [attachmentsArr]="parent.selectedAttachments" [showDelete]="true">
						</view-attachments>
					</div>
				</div>
				<div class="row mb-1">
					<div class="col">
						<button type="button" class="btn btn-xs btn-warning"
							(click)="parent.clearSelectedAttachments()">
							Cancel adding attachment
						</button>
					</div>
				</div>
				}
				<div class="row mb-3">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<table class="table table-bordered less-padding">
							<thead>
								<tr>
									<th style="width: 25% !important;">Name</th>
									<th style="width: 70% !important;">Files</th>
									<th style="width: 5% !important;">Action</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let bill of followupAdditionalFilesForEdit;let i = index;">
									<tr [ngClass]="{ 'orange': !bill.file_url || bill.file_url.length==0 }">
										<td>
											<input type="text" class="form-control" [(ngModel)]="bill.file_name" />
										</td>
										<td>
											<div class="row g-0">
												<div class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
													<app-file-upload [allowedFiles]="allowedAdditionalFiles"
														[uploadFolder]="'additional_follow_up_files'"
														(uploaded)="followUpAdditionalFileUploaded($event,i)">
													</app-file-upload>
												</div>
												<div class="col-lg-11 col-md-11 col-sm-12 col-xs-12 ps-0">
													<ng-container *ngIf="bill.file_url">
														<div *ngFor="let file of bill.file_url;let j = index;"
															class="icon-container">
															<file-icon [file]="file"></file-icon>
															<fa-icon [icon]="['fas', 'times-circle']"
																class="delete-icon text-danger" matTooltip="Delete"
																(click)="deleteFollowupAdditionalFile(file,i,j);"></fa-icon>
														</div>
													</ng-container>
												</div>
											</div>
											@if (parent.selectedAttachments.length && parent.selectedAttType=="file"){
											<div class="row g-0">
												<div class="col">
													<button matTooltip="Add attachments here" type="button"
														class="btn btn-xs btn-success"
														[disabled]="disableAdditionalFileAtt(i)"
														(click)="addMailAttachments(i,'additional_file');">
														@if(disableAdditionalFileAtt(i)){
														<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'">
														</fa-icon>
														}@else{
														<fa-icon [icon]="['fas', 'paperclip']">
														</fa-icon>
														}
													</button>
												</div>
											</div>
											}
										</td>
										<td>
											<button matTooltip="Delete" type="button" class="btn btn-sm btn-danger"
												(click)="removeAdditionalFileDetails(i);">
												<fa-icon [icon]="['fas', 'times']"></fa-icon>
											</button>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-primary float-start" (click)="addAdditionalFiles()">
					<fa-icon [icon]="['fas', 'plus']"></fa-icon>
					Add Files
				</button>
				<button type="button" class="btn btn-sm btn-success" (click)="saveAdditionalFiles()"
					[disabled]="saveAdditionalFileLoader">
					<fa-icon *ngIf="saveAdditionalFileLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!saveAdditionalFileLoader" [icon]="['fas', 'save']"></fa-icon>
					Save
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="otpModalFollowup" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<form [formGroup]="otpForm" (ngSubmit)="showOTP?verifyOTP():getOTP()">
				<div class="modal-header">
					<h4 class="modal-title">
						<strong>
							OTP Verification
						</strong>
					</h4>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<h5>
								OTP Verification is required for editing follow-up date for completed follow-up
							</h5>
						</div>
					</div>
					<div class="row mb-2" *ngIf="!showOTP">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showOTPFormError('reason')}"
									id="reason" formControlName="reason" placeholder="">
								<label for="reason">Please enter reason for editing*</label>
							</div>
							<p *ngIf="showOTPFormError('reason')" class="text-danger">
								<span *ngIf="f1.reason.errors?.required">
									Required
								</span>
								<span *ngIf="f1.reason.errors?.incorrect">
									{{customErrorOTP.reason}}
								</span>
							</p>
						</div>
					</div>
					<div class="row mb-2" *ngIf="showOTP">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showOTPFormError('otp')}" id="otp"
									formControlName="otp" placeholder="">
								<label for="otp">OTP*</label>
							</div>
							<p *ngIf="showOTPFormError('otp')" class="text-danger">
								<span *ngIf="f1.otp.errors?.required">
									Required
								</span>
								<span *ngIf="f1.otp.errors?.incorrect">
									{{customErrorOTP.otp}}
								</span>
							</p>
							<p class="text-success">
								OTP sent to {{otpMailId}}
							</p>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success" [disabled]="otpFormLoader">
						<fa-icon *ngIf="otpFormLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						{{showOTP?"Verify OTP":"Send OTP"}}
					</button>
					<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal fade" id="newFollowupModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<form [formGroup]="newFollowupForm" (ngSubmit)="createNewFollowup()">
				<div class="modal-header">
					<h4 class="modal-title">
						<strong>
							Create New Follow-up
						</strong>
					</h4>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="row mb-2">
						<div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
							<div class="input-group">
								<div class="form-floating">
									<input class="form-control"
										[ngClass]="{'is-invalid':showErrorNewFlwup('new_follow_up_date')}"
										placeholder="" formControlName="new_follow_up_date" ngbDatepicker
										id="new_follow_up_date" #new_follow_up_date="ngbDatepicker" [minDate]="minDate"
										[container]="'body'" />
									<label for="new_follow_up_date">Follow-up Date*</label>
								</div>
								<button class="btn btn-outline-secondary" (click)="new_follow_up_date.toggle()"
									type="button">
									<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
								</button>
							</div>
							<p *ngIf="showErrorNewFlwup('new_follow_up_date')" class="text-danger">
								<span *ngIf="f2.new_follow_up_date.errors?.required">
									Required
								</span>
								<span *ngIf="f2.new_follow_up_date.errors?.incorrect">
									{{customErrorNewFlwup.new_follow_up_date}}
								</span>
							</p>
						</div>
						<div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
							<ng-select [ngClass]="{'is-invalid':showErrorNewFlwup('new_visit_type_id')}"
								[items]="parent.allVisitType" bindLabel="name" bindValue="id" [clearable]="true"
								id="new_visit_type_id" formControlName="new_visit_type_id"
								placeholder="Appointment Type*" [appearance]="'outline'">
								<ng-template ng-label-tmp let-item="item">
									<img src="../../assets/img/appt-types/{{parent.appt_type_images[item.name]}}"
										class="appt-type-img" />
									{{item.name}}
								</ng-template>
								<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
									<img src="../../assets/img/appt-types/{{parent.appt_type_images[item.name]}}"
										class="appt-type-img" />
									{{item.name}}
								</ng-template>
							</ng-select>
							<p *ngIf="showErrorNewFlwup('new_visit_type_id')" class="text-danger">
								<span *ngIf="f2.new_visit_type_id.errors?.required">
									Required
								</span>
								<span *ngIf="f2.new_visit_type_id.errors?.incorrect">
									{{customErrorNewFlwup.new_visit_type_id}}
								</span>
							</p>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success" [disabled]="newFollowupLoader">
						<fa-icon *ngIf="newFollowupLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						Create Follow-up
					</button>
					<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal fade" id="questionnaireModalFoll" role="dialog">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					<strong>
						Please answer following questions
					</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal" (click)="gotoList()"></button>
			</div>
			<div class="modal-body">
				<div class="row g-0">
					<div class="col">
						<div class="card" @fadeInOut>
							<div class="card-header">
								<h5 style="font-size: 12px !important;" class="card-title text-dark mb-0">
									Questionnaire
								</h5>
							</div>
							<div class="card-body p-1">
								@if (Questions.length && !questionError) {
								<table class="table table-bordered questions-table">
									<tbody>
										@for (que of Questions; track $index) {
										<tr>
											<td>
												<p class="mb-0 text-dark">
													{{$index + 1}}.
													{{que.question}}
													<fa-icon [icon]="['fas','times']" class="text-danger float-end"
														role="button" matTooltip="Remove"
														(click)="removeQuestion($index)">
													</fa-icon>
												</p>
												<mat-radio-group [(ngModel)]="que.answer" (change)="formChanged()">
													@for (a of que.options; track $index) {
													<mat-radio-button [value]="a" [color]="'primary'">
														{{a}}
													</mat-radio-button>
													}
												</mat-radio-group>
											</td>
										</tr>
										}
									</tbody>
								</table>
								}@else if (questionError) {
								<p class="text-danger">
									{{questionError}}
								</p>
								}@else {
								<h4 class="mb-0 ps-2">
									No Questions
								</h4>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveQuestions()">
					@if(savingQuestionnaire){
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					}@else{
					<fa-icon [icon]="['fas','save']"></fa-icon>
					}
					Save
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal" (click)="gotoList()">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>